import React from 'react'
import FourDotLoader from 'components/FourDotLoader'

export const ChartLoader = () => {
  return (

    <div className='chart-loader'>
      <FourDotLoader hasBottomMargin />
    </div>
  )
}